import { render, staticRenderFns } from "./StaffFooter.vue?vue&type=template&id=1819b9c0&scoped=true"
import script from "./StaffFooter.vue?vue&type=script&lang=js"
export * from "./StaffFooter.vue?vue&type=script&lang=js"
import style0 from "./StaffFooter.vue?vue&type=style&index=0&id=1819b9c0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1819b9c0",
  null
  
)

export default component.exports